<template>
  <v-container fluid grid-list-xs style="padding: 0;">
    <MonitorList :system="true"></MonitorList>
  </v-container>
</template>

<script>
import MonitorList from '../monitor/List.vue'

export default {
  components: {
    MonitorList
  }
}
</script>
